<template>
  <Flex grow justify-between truncate border-b-2 border-primary-500 opacity-100 w-tabs>
    <Flex truncate ml-1 self-center>
      <span>{{ componentName }}</span>
    </Flex>
    <Flex self-center>
      <Icon
        class="self-end p-1 action-icon"
        src="bwise/action_add"
        v-on:click="addComponent()"
        v-tooltip.bottom="'Add New'"
      >
      </Icon>
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import Icon from '@wizer/core/components/icon/Icon.vue'

export default {
  name: 'DesignerActionBar',
  components: {
    Flex,
    Icon,
  },
  props: {
    componentName: String,
    addComponent: Function,
  },
}
</script>

<style scoped>
.action-icon:hover {
  @apply bg-gray-200;
}
</style>
